import { toast } from "react-toastify";
import { Axios } from "../Axios";

const sendSms = async (phone) => {
  const response = await Axios.post("/users/send-sms", { phone });
  toast.success("کد ارسال شد");
  return response;
};
export default sendSms;
